/*
 * @Author: your name
 * @Date: 2020-12-22 17:56:09
 * @LastEditTime: 2021-04-20 16:01:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\AudioManager.js
 */

import * as THREE from 'three'

export class AudioManager {
  /**
   * 播放器控制
   * @param {HTMLAudioElement} bgmDom bgm的元素
   * @param {HTMLAudioElement} introDom 介绍的元素
   * @param {boolean} playable 是否可以播放音频
   * @param {boolean} playOnHotpoint 是否播放热点的时候还播放bgm
   */
  constructor (bgmDom, introDom, playable, playOnHotpoint) {
    /**
     * @type {HTMLAudioElement} 背景音频播放器
     */
    this.bgmElement = bgmDom
    /**
     * @type {HTMLAudioElement} 介绍音频播放器
     */
    this.introElement = introDom

    /**
     * @type {HTMLAudioElement} 热点音频播放器
     */
    this.hpAudioElement = new Audio()
    this.hpAudioElement.onloadedmetadata = () => {
      this.hpAudioElement.play()
    }

    /**
     * @type {HTMLAudioElement} 热点介绍音频播放器
     */
    this.hpIntroElement = new Audio()
    this.hpIntroElement.onloadedmetadata = () => {
      this.hpIntroElement.play()
    }

    /**
     * @type {boolean} 是否可以播放bgm
     */
    this.playable = playable
    /**
     * @type {boolean} 是否在热点播放
     */
    this.isPlayOnHotpoint = playOnHotpoint
    /**
     * @type {boolean} 是否在播放热点
     */
    this.isPlayingHp = false
    /**
     * @type {boolean} 是否已经暂停
     */
    this._paused = true
  }

  /**
   * 重新初始化
   * @param {HTMLAudioElement} bgmDom bgm元素
   * @param {HTMLAudioElement} introDom 介绍用元素
   */
  init (bgmDom, introDom) {
    this.bgmElement = bgmDom
    this.introElement = introDom
  }

  /**
   * 播放热点
   * @param {string} url 音频url
   * @param {string} introUrl 介绍url
   */
  playHp (url, introUrl) {
    if (!this.playOnHotpoint && !this.paused) {
      this.pauseBgm()
    }

    if (url) {
      this.hpAudioElement.src = url
      this.hpAudioElement.load()
    }

    if (introUrl) {
      this.hpIntroElement.src = introUrl
      this.hpIntroElement.load()

      this.pauseIntro()
    }
  }

  /**
   * 暂停热点
   */
  stopHp () {
    if (!this.playOnHotpoint && !this.paused) {
      this.playBgm()
    }
    this.hpAudioElement.pause()
    this.hpIntroElement.pause()

    this.playIntro()
  }

  /**
   * 是否被暂停
   */
  get paused () {
    return this._paused
  }

  /**
   * 是否被暂停
   */
  set paused (value) {
    if (this._paused !== value) {
      if (value) {
        this.pauseBgm()
      } else {
        this.playBgm()
      }
      this._paused = value
    }
  }

  /**
   * 是暂停
   */
  get intorPaused () {
    return this.introElement.paused
  }

  /**
   * 介绍是否被暂停
   */
  set intorPaused (value) {
    if (this.introElement && this.introElement.paused !== value && !this.introElement.ended) {
      if (!value) {
        this.introElement.play()
        console.log('play')
      } else { this.introElement.pause() }
    }
  }

  /**
   * 暂停播放bgm
   */
  pauseBgm () {
    if (!this.playable || !this.bgmElement || this.bgmElement.paused) return
    this.bgmElement.pause()
  }

  /**
   * 开始播放bgm
   */
  playBgm () {
    if (!this.playable || !this.bgmElement || !this.bgmElement.paused || !this.bgmElement.src) return
    this.bgmElement.play()
    this.bgmElement.loop = true
  }

  pauseIntro () {
    if (!this.playable || !this.introElement || this.introElement.paused) return
    this.introElement.pause()
  }

  playIntro () {
    if (!this.playable || !this.introElement || this.introElement.ended || this.introElement.paused || !this.introElement.src) return
    this.introElement.play()
  }
}
